import React from 'react';
import Task from './Task';
import { Droppable } from 'react-beautiful-dnd';
import { TaskGroupContainer, TaskGroupTitle, TaskList } from './style/style';

const TaskGroup = (props) => {
  return (
    <TaskGroupContainer className="task_group">
      <TaskGroupTitle>{props.group.title}</TaskGroupTitle>
      <Droppable droppableId={props.group.id}>
        {(provided, snapshot) => (
          <TaskList
            {...provided.droppableProps}
            ref={provided.innerRef}
            isDraggingOver={snapshot.isDraggingOver}
          >
            {props.tasks.map((task, index) => (
              <Task onDoubleClick={props.onDoubleClick} task={task} index={index} key={index} />
            ))}
            {provided.placeholder}
          </TaskList>
        )}
      </Droppable>
    </TaskGroupContainer>
  );
};

export default TaskGroup;
